import angular from 'angular';

const module = angular.module('whyline.filters.overbooking', []);

const filter = ($translate) => (slot) => {
  const showOverbookingText = !slot.isEdit || slot.appointmentDateSelected !== slot.hour;
  const overbookingText =
    slot.overbooking && showOverbookingText ? $translate.instant('overbooking') : '';
  return `${overbookingText}`;
};

module.exports = module.filter('overbooking', filter);
